module.exports = __webpack_public_path__ + "img/cn.c9ba110d.png";